var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9136 3.20938C16.1901 1.56141 14.5955 0.501641 12.8374 0.500116C11.6173 0.508642 10.4494 1.01064 9.5864 1.89768C9.38634 2.10344 9.20295 2.32634 8.96954 2.58354C8.71947 2.30919 8.51941 2.052 8.286 1.82909C7.4783 0.980688 6.37289 0.501838 5.21839 0.500116C4.79038 0.497057 4.36399 0.554758 3.95134 0.671705C2.02474 1.19773 0.679248 2.98544 0.667 5.03548C0.650443 6.36539 1.18373 7.63997 2.13412 8.54194C3.5012 9.95652 6.93559 13.6859 8.4027 15.2376C8.55982 15.4053 8.77648 15.5 9.00289 15.5C9.22929 15.5 9.44595 15.4053 9.60307 15.2376C11.3286 13.3944 16.2051 8.16472 16.3218 8.0104C17.41 6.66456 17.6408 4.79194 16.9136 3.20938Z",
    fill: "#009745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart_icon.36b5dd6795a082c3cbcf8b68b746187e.svg";
export { ForwardRef as ReactComponent };